import * as fromDatatype from "../datatype-library/index";


export interface bl_wms_container_space_scan_session_hdr_queue_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    session_group_guid: fromDatatype.GuidDataFieldInterface;
    scan_code: fromDatatype.VarcharDatatypeInterface;
    container_hdr_guid: fromDatatype.GuidDataFieldInterface;
    container_line_guid: fromDatatype.GuidDataFieldInterface;
    space_guid: fromDatatype.GuidDataFieldInterface;
    process_status: fromDatatype.VarcharDatatypeInterface;
    remarks: fromDatatype.VarcharDatatypeInterface;
    action_type: fromDatatype.VarcharDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;

}


export class bl_wms_container_space_scan_session_hdr_queue_RowClass
    implements bl_wms_container_space_scan_session_hdr_queue_RowInterface {
        guid: fromDatatype.GuidDataFieldInterface;
        session_group_guid: fromDatatype.GuidDataFieldInterface;
        scan_code: fromDatatype.VarcharDatatypeInterface;
        container_hdr_guid: fromDatatype.GuidDataFieldInterface;
        container_line_guid: fromDatatype.GuidDataFieldInterface;
        space_guid: fromDatatype.GuidDataFieldInterface;
        process_status: fromDatatype.VarcharDatatypeInterface;
        remarks: fromDatatype.VarcharDatatypeInterface;
        action_type: fromDatatype.VarcharDatatypeInterface;
        property_json: fromDatatype.JsonDatatypeInterface;
        namespace: fromDatatype.VarcharDatatypeInterface;
        acl_config: fromDatatype.JsonDatatypeInterface;
        acl_policy: fromDatatype.JsonDatatypeInterface;
        created_date: fromDatatype.TimestampTzDatatypeInterface;
        updated_date: fromDatatype.TimestampTzDatatypeInterface;
        created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
        updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
        status: fromDatatype.StatusDataFieldInterface;
        revision: fromDatatype.GuidDataFieldInterface;
        vrsn: fromDatatype.VrsnDataFieldInterface;

}